import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../services/firebase';

/**
 * Real-time listener for a single bout document.
 */
export function useBout(boutId) {
  const [bout, setBout] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!boutId) {
      setBout(null);
      setLoading(false);
      return;
    }

    const unsub = onSnapshot(
      doc(db, 'bouts', boutId),
      (snap) => {
        if (snap.exists()) {
          setBout({ id: snap.id, ...snap.data() });
        } else {
          setBout(null);
        }
        setLoading(false);
      },
      (err) => {
        console.error('Error listening to bout:', err);
        setLoading(false);
      }
    );

    return unsub;
  }, [boutId]);

  return { bout, loading };
}
